import React from 'react';
import { MessageSquare, Mic, Layers } from 'lucide-react';
export function Providers() {
  const providers = ['OpenAI', 'Anthropic', 'Grok', 'Gemini', 'Mistral', 'Fireworks', 'Bedrock', 'OpenRouter', 'Novita'];
  const endpoints = [{
    path: '/v1/chat/completions',
    name: 'Chat Completions',
    desc: 'Standard LLM requests',
    icon: <MessageSquare className="w-4 h-4 text-blue-600" data-id="element-330" />
  }, {
    path: '/v1/audio/transcriptions',
    name: 'Transcriptions',
    desc: 'Transcribe audio requests',
    icon: <Mic className="w-4 h-4 text-blue-600" data-id="element-331" />
  }, {
    path: '/v1/embeddings',
    name: 'Embeddings',
    desc: 'Vector embedding requests',
    icon: <Layers className="w-4 h-4 text-blue-600" data-id="element-332" />
  }];
  return <section className="py-20 bg-white border-y border-gray-50" data-id="element-333">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-334">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-335">
          {/* Providers Column */}
          <div data-id="element-336">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-8" data-id="element-337">
              Supported LLM Providers
            </p>
            <div className="grid grid-cols-3 gap-y-8 gap-x-4 opacity-70" data-id="element-338">
              {providers.map(name => <span key={name} className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-339">
                  {name}
                </span>)}
            </div>
          </div>

          {/* Endpoints Column */}
          <div data-id="element-340">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-8" data-id="element-341">
              OpenAI-Compatible Endpoints
            </p>
            <div className="space-y-6" data-id="element-342">
              {endpoints.map(ep => <div key={ep.path} className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100 group hover:border-blue-200 transition-colors" data-id="element-343">
                  <div className="w-10 h-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center shrink-0 shadow-sm" data-id="element-344">
                    {ep.icon}
                  </div>
                  <div data-id="element-345">
                    <div className="flex items-center gap-2 mb-1" data-id="element-346">
                      <span className="text-sm font-bold text-gray-900" data-id="element-347">
                        {ep.name}
                      </span>
                      <code className="text-[10px] font-mono bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded uppercase font-bold" data-id="element-348">
                        OpenAI SDK
                      </code>
                    </div>
                    <code className="text-xs text-gray-500 font-mono block mb-1" data-id="element-349">
                      {ep.path}
                    </code>
                    <p className="text-xs text-gray-400" data-id="element-350">{ep.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}